import { ref, onMounted, onUnmounted } from 'vue'

export const PANEL_MOBILE_BREAKPOINT = 768

export function usePanelMobile(breakpoint = PANEL_MOBILE_BREAKPOINT) {
  const isMobile = ref(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  )

  const update = () => {
    isMobile.value = window.innerWidth < breakpoint
  }

  onMounted(() => {
    update()
    window.addEventListener('resize', update)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', update)
  })

  return { isMobile }
}
